import styled from 'styled-components';
import { prop } from 'styled-tools';
import { key } from 'styled-theme';

import { DOTS_COUNT } from '../constants';

const dots = (): string => {
  let degrees = 0;
  let delay = 1.2;
  let styles = '';

  for (let i = 2; i <= DOTS_COUNT; i++) {
    degrees += 30;
    delay -= 0.1;
    styles += `
      &:nth-child(${i}) {
        transform: rotate(${degrees}deg);

        &:before {
          animation-delay: -${delay.toFixed(1)}s;
        }
      }
    `;
  }

  return styles;
};

export default styled.div`
  display: inline-block;
  position: relative;
  width: ${prop('size', '1em')};
  height: ${prop('size', '1em')};

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;

    &:before {
      content: '';
      display: block;
      margin: 0 auto;
      width: 15%;
      height: 15%;
      background-color: ${prop('color', key('colors.white'))};
      border-radius: 100%;
      animation: loader 1.2s infinite ease-in-out both;
    }

    ${dots()};
  }

  @keyframes loader {
    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1);
    }
  }
`;
